import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {optionFilter} from "../../../utils/filters";
import {PidFormatter, remoteOptionFormatter} from "../../../utils/formatters";

class WriteOffList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid || "WriteOffList"}
                {...props}
                view="adminlist"
                searchfield={true}
                columns={ {
                    "id": {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "pid": {
                        header: 'Azonosító',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: PidFormatter,
                    },
                    "writeoff_type": {
                        header: 'Típus',
                        width: 1,
                        sortable,
                        filterable: optionFilter("WriteoffType"),
                        renderer: remoteOptionFormatter("WriteoffType")
                    },
                    "origin.name": {
                        header: 'Honnan',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "partner.name": {
                        header: 'Partner',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "destination.name": {
                        header: 'Hova',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "transaction_date": {
                        header: 'Szállítás dátuma',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "StockOperationState.optionlabel": {
                        header: 'Státusz',
                        width: 2,
                        sortable,
                        filterField: 'state',
                        operator: '=',
                        filterable: optionFilter("StockOperationState")
                    }
                } }
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default WriteOffList;
